import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=17a72b7b&scoped=true&lang=pug"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CustomCheckbox.vue?vue&type=style&index=0&id=17a72b7b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a72b7b",
  null
  
)

export default component.exports